import React, { useState }  from 'react'
import { StyleSheet, ScrollView, View } from 'react-native'
import { Button, Text, Radio, CheckBox } from '@ui-kitten/components'
import StyledTextInput from '../../components/StyledTextInput'
import { HintView } from '../../components/HintView'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'
import { priceTypesAtom } from '../../global/AtomsProvider'

export default function StickerPrinterSettingsScreen( { navigation, route } ) {
  const { t } = useTranslation()
  const { initialSettings, saveStickerPrinterSettings } = route.params
  const priceTypes = useAtomValue(priceTypesAtom)
  const [stickerHeight, setStickerHeight] = useState(initialSettings.stickerHeight?.toString() || '112')
  const [showDate, setShowDate] = useState(initialSettings.showDate)
  const [generalFontSize, setGeneralFontSize] = useState(initialSettings.generalFontSize?.toString() || '10')
  const [priceFontSize, setPriceFontSize] = useState(initialSettings.priceFontSize?.toString() || '12')
  const [selectedPriceTypes, setSelectedPriceTypes] = useState(initialSettings.selectedPriceTypes || [])

  const togglePriceType = (priceTypeId) => {
    if (selectedPriceTypes.includes(priceTypeId)) {
      setSelectedPriceTypes(selectedPriceTypes.filter(id => id !== priceTypeId))
    } else {
      setSelectedPriceTypes([...selectedPriceTypes, priceTypeId])
    }
  }

  const save = async () => {
    saveStickerPrinterSettings({
      stickerHeight: parseInt(stickerHeight),
      showDate,
      generalFontSize: parseInt(generalFontSize),
      priceFontSize: parseInt(priceFontSize),
      selectedPriceTypes
    })
    navigation.goBack()
  }
  
  return (
    <ScrollView style={styles.container}>
      <Text category='label' style={styles.label}>
        {t('printStickers.stickerHeight')}
      </Text>
      <StyledTextInput 
        value={stickerHeight}
        onChangeText={setStickerHeight}
        keyboardType='number-pad'
        style={styles.inputField}
        returnKeyType='done'
      />
      <HintView 
        text={t('printStickers.stickerHeightHint')}
        iconName='alert-circle-outline' style={{marginVertical: 10}} 
      />
      <Text category='label' style={styles.label}>
        {t('printStickers.generalFontSize')}
      </Text>
      <StyledTextInput 
        value={generalFontSize}
        onChangeText={setGeneralFontSize}
        keyboardType='number-pad'
        style={styles.inputField}
        returnKeyType='done'
      />
      <Text category='label' style={styles.label}>
        {t('printStickers.priceFontSize')}
      </Text>
      <StyledTextInput 
        value={priceFontSize}
        onChangeText={setPriceFontSize}
        keyboardType='number-pad'
        style={styles.inputField}
        returnKeyType='done'
      />
      <Text category='label' style={styles.label}>
      {t('printStickers.printDateOnSticker')}
      </Text>
      <Radio style={styles.radio} checked={showDate} onChange={() => {setShowDate(true)}}>
      {t('printStickers.print')}
      </Radio>
      <Radio style={styles.radio} checked={!showDate} onChange={() => {setShowDate(false)}}>
      {t('printStickers.doNotPrint')}
      </Radio>
      
      {priceTypes && priceTypes.length > 0 && (
        <View style={styles.priceTypesSection}>
          <Text category='label' style={styles.label}>
            {t('printStickers.additionalPricesToShow')}
          </Text>
          <HintView 
            text={t('printStickers.additionalPricesToShowHint')}
            iconName='alert-circle-outline' 
            style={{marginBottom: 10}} 
          />
          {priceTypes.map((priceType) => (
            <CheckBox
              key={priceType.id}
              style={styles.checkbox}
              checked={selectedPriceTypes.includes(priceType.id)}
              onChange={() => togglePriceType(priceType.id)}
            >
              {priceType.name}
            </CheckBox>
          ))}
        </View>
      )}
      
      <Button style={styles.submitButton} onPress={save}>{t('save')}</Button>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
  },
  inputField: {

  },
  label: {
    marginTop: 10,
    marginBottom: 5
  },
  radio: {
    marginBottom: 5,
  },
  priceTypesSection: {
    marginBottom: 5
  },
  checkbox: {
    marginBottom: 5,
  },
  submitButton: {
    marginTop: 20
  }
})